import { render, staticRenderFns } from "./selector-key-value.vue?vue&type=template&id=be1ae15a&scoped=true"
import script from "./selector-key-value.vue?vue&type=script&lang=js"
export * from "./selector-key-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1ae15a",
  null
  
)

export default component.exports